var _defs, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _polygon, _polygon2, _rect9, _rect10, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerificateurAbsenceDeTension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "v\\xE9rificateur_de_absence_de_tension",
    "data-name": "v\\xE9rificateur de'absence de tension",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 347 1473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-18{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#2e2e2e;}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_13);}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_13-2);}.cls-6{fill:#050706;}.cls-7{fill:#161616;}.cls-8{fill:#e2b25d;}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_22);}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_22-2);}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_28);}.cls-12{fill:#232323;}.cls-13{fill:url(#D\xE9grad\xE9_sans_nom_49);}.cls-14{fill:#4c504f;}.cls-15{fill:#3a4245;}.cls-16{fill:#2d2d2d;}.cls-17{fill:#b57a47;opacity:0.68;}.cls-18{stroke:#c6c6c6;stroke-miterlimit:10;stroke-width:7px;}.cls-19{fill:#c6c6c6;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-998 -346)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1030,1108V982H998v-9h32V735h8V455h15V397l10-36h5l12,38v56h15V744s13-12,41-9V454h15V397l10-36h7l12,36v57h17V735s95,17,108,29c6,8,5,11,5,11v244h35v13l-35,1v84l-33,220-9,312c.12,5.43-4.35,7.19-10,8,0,0-90,4-103,13-2,27-4,84-4,84h-5l-2,65h-22l-1-61-10-3,1-82s-11-5-11-8-2-332-2-332l-4.34,236.48-4.66.52v183h-28V1568l-8-1-1-213Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_13",
    x1: 50,
    y1: 54.5,
    x2: 88,
    y2: 54.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_13-2",
    x1: 149,
    y1: 54.5,
    x2: 187,
    y2: 54.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22",
    x1: 25,
    y1: 432.5,
    x2: 96,
    y2: 432.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-2",
    x1: 132,
    y1: 249,
    x2: 203,
    y2: 249,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_28",
    x1: 918,
    y1: 778.5,
    x2: 847,
    y2: 778.5,
    gradientTransform: "matrix(-1, 0, 0, 1, 1015, -346)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#0e0e0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#757575",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#565656",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#3b3b3b",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#252525",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#141414",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#090909",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#020202",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_49",
    x1: 1107,
    y1: 1339.37,
    x2: 1023,
    y2: 1339.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b57a47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#dcab5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#e2b25d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b57a47"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "v\xE9rificateur d&amp;apos;absence de tension") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1030,1108V982H998v-9h32V735h8V455h15V397l10-36h5l12,38v56h15V744s13-12,41-9V454h15V397l10-36h7l12,36v57h17V735s95,17,108,29c6,8,5,11,5,11v244h35v13l-35,1v84l-33,220-9,312c.12,5.43-4.35,7.19-10,8,0,0-90,4-103,13-2,27-4,84-4,84h-5l-2,65h-22l-1-61-10-3,1-82s-11-5-11-8-2-332-2-332l-4.34,236.48-4.66.52v183h-28V1568l-8-1-1-213Z",
    transform: "translate(-998 -346)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "55 109 82 109 88 55 86 4 50 0 50 64 55 109"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "154 109 181 109 187 55 185 4 149 0 149 64 154 109"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 155.5,
    cy: 816.5,
    r: 27.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1099.22,1358.77l8.26-230.33S1112,1361,1112,1387s-4,171,0,171,94-12,94-12,4-247,18-308,12-110,12-110l21-10-26,296v161l-132,4Z",
    transform: "translate(-998 -346)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 154,
    cy: 818,
    r: 26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1100.41,1565.38S1216,1559,1222,1548s0-135,8-202,27-229,27-229h75l-32,543-149,94s-17,7-40,0c-7-12-17-149-17-149Z",
    transform: "translate(-998 -346)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "32 762 96 762 96 398 96 103 32 109 25 537 32 762"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "139 390 203 390 203 231.47 203 108 134 108 132 292.01 139 390"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "161 762 97 762 97 398 97 103 161 109 168 537 161 762"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    y: 627,
    width: 97,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1023,1108h84l-9.6,311.84L1095,1569s-21,5-41-2S1023,1108,1023,1108Z",
    transform: "translate(-998 -346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1113,1553c15,2,101-8,99-13-4-4-66,7-89,5C1117,1544,1098,1551,1113,1553Z",
    transform: "translate(-998 -346)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "109 782 235 783 259 772 110 767 109 782"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "113 729 306 731 306 767 109 767 113 729"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1115,1067l5-318s129-12,176,24l4,294Z",
    transform: "translate(-998 -346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1110,1565s-2,90,3,93,134-11,141-17,13-291,16-313,34-210.5,34-210.5l19,.5-45,556H1160l-9,80c-3.87,2.41-7.72,3.52-11.56,2.65L1143,1674l-23,1,3.35,81.61L1111,1757l-6-14,2-64-10-15s-1-99,1-99Z",
    transform: "translate(-998 -346)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 163.5,
    y: 687.5,
    width: 24,
    height: 24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 227.5,
    y: 687.5,
    width: 24,
    height: 24
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 189.5,
    y: 647.5,
    width: 36,
    height: 24
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 189.5,
    y: 610.5,
    width: 36,
    height: 24
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 189.5,
    y: 573.5,
    width: 36,
    height: 24
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 189.5,
    y: 536.5,
    width: 36,
    height: 24
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 189.5,
    y: 493.5,
    width: 36,
    height: 24
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 189.5,
    y: 445.5,
    width: 36,
    height: 24
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "245.5 558.5 286.5 558.5 266.5 523.5 245.5 558.5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "245.5 475 286.5 475 266.5 440 245.5 475"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 169,
    y: 497,
    width: 6,
    height: 23
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 151,
    y: 506,
    width: 14,
    height: 6
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "143 497 143 524 123 510 143 497"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificateurAbsenceDeTension);
export default __webpack_public_path__ + "static/media/verificateur_absence_de_tension.ca4288dab6f2ff67001a79a2cf4f8858.svg";
export { ForwardRef as ReactComponent };